<template>
  <section id="page-search">
    <div class="container">
      <div class="row">
        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content fb-bg-dark">
          <h3>{{ $t('message.title.main.search') }}</h3>
        </div>
      </div>

      <div class="row">
        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <input id="fb-search-query" type="text" v-model="query" :placeholder="$t('message.form.placeholder.query')">
        </div>
      </div>

      <clearfix :wide="true"></clearfix>

      <div class="row">
        <div class="col-sm-12 content fb-bg-light" v-show="query.length < minLength">
          {{ $t('message.text.no_search_results') }}
        </div>
        <div class="col-sm-12 content fb-bg-light" v-show="query.length >= minLength">
          <p v-html="$t('message.text.displaying_search_results', {count: results.length, query: query})"></p>
          <div v-show="searching"><loading-spinner></loading-spinner></div>
          <div v-for="foobar in results">
            <a href="#" @click.prevent="$router.push({ name: 'Foobar', params: { id: foobar.id } })"><strong>{{ foobar.title }}</strong></a>
            <div v-html="foobar.description" class="search-result description"></div>
          </div>
        </div>
      </div>

      <clearfix :biggest="true"></clearfix>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '@/components/utils/Clearfix'
  import config from './Config'
  import LoadingSpinner from '@/components/utils/LoadingSpinner'

  Vue.use(VueAxios, axios)

  export default {
    data() {
      return {
        minLength: 2,
        query: '',
        results: [],
        searching: false
      }
    },
    methods: {
      search() {
        if (this.query < this.minLength) return

        this.results = []
        this.searching = true

        Vue.axios.get(config.urls.search, { params: {query: this.query} })
          .then((response) => {
            this.results = response.data
            this.searching = false
          })
          .catch(() => {
            this.searching = false
            console.log('Error occurred while trying to process the search query!')
          })
      }
    },
    watch: {
      query: function (val, old) {
        if (val.length >= this.minLength) {
          this.search()
        } else {
          this.results = []
        }
      }
    },
    components: {
      Clearfix, LoadingSpinner
    }
  }
</script>

<style>
  #page-search {
    background: url('../../assets/img/bg/pattern.jpg') 50% 0 fixed;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// FoobarSearch.vue?6ca7271f